import React, { useState, useEffect, useContext } from 'react';
import isEmail from 'validator/lib/isEmail';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import RegisterEmailStep from 'components/Auth/Register/RegisterEmailStep';

import styles from './Register.module.scss';
import { useForm } from 'hooks/common/useForm';
import PasswordEmailStep from 'components/Auth/Register/PasswordEmailStep';
import { useTranslation } from 'react-i18next';
import { RightArrowIcon } from 'components/common/icons';
import makeRequest from 'makeRequest';
import Routes from 'constants/Routes';
import { getQueryStringParameter } from 'helpers/getParamFromQuery';
import { UserContext } from 'context/UserContext';

export const STEPS = {
    email: 'email',
    password: 'password',
};

const validateEmail = async (values, t) => {
    const result = {};
    if (!isEmail(values.email)) {
        result.email = t('auth:error.invalidEmail');
        return result;
    }
    try {
        const path = 'email';
        await makeRequest({ path, data: { email: values.email } });
        sessionStorage.setItem('confirmEmail', values.email);
    } catch (e) {
        result.email = e;
    }
    return result;
};
const validatePassword = async (values, t) => {
    const result = {};
    if (!values.password.trim()) result.password = t('auth:error.password');
    if (values.password.trim() !== values.confirmPassword.trim())
        result.confirmPassword = t('auth:error.passwordConfirm');
    return result;
};
const validations = {
    [STEPS.email]: validateEmail,
    [STEPS.password]: validatePassword,
};

const Register = () => {
    const params = useParams();
    const location = useLocation();
    const { role } = params;
    const { t } = useTranslation();
    const { values, onChangeField } = useForm({ values: { email: '', password: '', confirmPassword: '' } });
    const [step, setStep] = useState(STEPS.email);
    const [errors, setErrors] = useState({});
    const history = useHistory();
    const { register } = useContext(UserContext);

    useEffect(() => {
        const newEmail = getQueryStringParameter(location.search, 'fromEmail');
        if (!newEmail) return;
        onChangeField({ target: { name: 'email', value: newEmail } });
        handleSetStep(STEPS.password);
    }, []);

    const handleSetStep = async (newStep) => {
        const validation = validations[step];
        const errors = await validation(values, t);
        if (Object.keys(errors).length) return setErrors(errors);
        setStep(newStep);
        if (newStep === step && step === STEPS.password) {
            const data = { email: values.email, password: values.password, role };
            register(data, (isExternalInvite) => {
                if (isExternalInvite) {
                    history.push(Routes.welcome.path);
                } else history.push(Routes.confirmRegistration.path);
            });
        }
    };

    return (
        <>
            <div
                className={styles.wrapper}
                onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                        return handleSetStep(STEPS.password);
                    }
                }}
            >
                {step === STEPS.email && (
                    <RegisterEmailStep
                        values={values}
                        errors={errors}
                        onChangeField={onChangeField}
                        setStep={handleSetStep}
                    />
                )}
                {step === STEPS.password && (
                    <PasswordEmailStep
                        values={values}
                        errors={errors}
                        onChangeField={onChangeField}
                        setStep={handleSetStep}
                    />
                )}
            </div>
            {step === STEPS.password && (
                <div className={styles.back} onClick={() => setStep(STEPS.email)}>
                    <RightArrowIcon className={styles.icon} />
                    {t('auth:text.backToEmail')}
                </div>
            )}
        </>
    );
};

export default Register;
